module.exports = __webpack_public_path__ + "img/sleeve upper flounce length.8e221cb8.png";